import React from 'react'
import styles from './svg.module.css'
// import { Link } from 'gatsby'

export default function header() {
  return (
    <div className={styles.rotateConatiner}>
    <div className={styles.rotate}>
      <svg viewBox="0 0 200 200"><defs><path id="circle" d="M 100 50 A 50 50 0 1 1 100 150 A 25 25 0 1 1 100 50 
"></path></defs><text><textPath href="#circle" fill="red">Ajay Doddapaneni</textPath><textPath href="#circle" startOffset="50%" fill="red">Ajay Doddapaneni</textPath></text></svg>
    </div>
    </div>
  )
}